import angular from 'angular';
import constants from 'app/constants';
import {
  bcpDataService,
  bcpSharedModelService,
  loaderService,
  ssDialogService,
  userService,
  orgDataService,
} from 'app/services';
import {
  alerts,
  helpTooltip,
  convertToNumber,
  appReports,
} from 'app/components/global';
import addAssessmentDialog from './assessments/dialog.addAssessmentDialog';
import settingsDialog from './dialog.settingsDialog';
import assessments from './assessments';
import controller from './bcp.controller';


export const routeConfig = {
  template: require('./bcp.html'),
  controller: 'BCPController',
  controllerAs: 'bcpVM',
};

export default angular.module('app.components.advisory.bcp', [
  addAssessmentDialog,
  alerts,
  appReports,
  assessments,
  bcpDataService,
  bcpSharedModelService,
  constants,
  convertToNumber,
  helpTooltip,
  loaderService,
  settingsDialog,
  ssDialogService,
  userService,
  orgDataService,
])
  .controller('BCPController', controller)
  .name;

console.log('app.components.advisory.bcp created');
